var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('PageTitle',{attrs:{"title":_vm.pageTitle}}),_c('SchoolBreadcrumb',{attrs:{"crumbs":_vm.crumbs,"include-school":_vm.includeSchool}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }